namespace GpScot.ResponsiveTables {

    export function init() {
        responsiveRTETables();
    }

    enum CLASSES {
        RTE = 'nhs-sf-rte',
    }

    // Enforce all user created tables to be responsive
    const responsiveRTETables = () => {
        document.querySelectorAll(`.${CLASSES.RTE} > table`).forEach((table) => {
            let adjustTableAttribute = false;
            table.querySelectorAll('tbody').forEach((tbody, i) => {
                adjustTableAttribute = tbody.offsetWidth > 595;
                if (adjustTableAttribute) {
                    tbody.setAttribute('table-id', i.toString());
                }
            });
            if (adjustTableAttribute) {
                table.setAttribute(
                    'style',
                    'width: 100%; overflow-x: scroll !important;border-right:2px solid;border: rem-calc(1) solid;border-color: #878a8c !important;'
                );
            }
        });
    }

}
